import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductListItemModel } from 'src/app/models/catalog/product-list-item.model';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePagedPage } from '../base-paged-page';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss'],
    standalone: false
})
export class ProductsComponent extends BasePagedPage<string, {
  id: string,
  name: string,
  price: number,
  image?: string,
  isPublished?: boolean
}> implements OnInit {

  public constructor(private mApiService: ApiService, private mRoute: Router) {
    super();
  }

  ngOnInit(): void {
    this.getData(1);
  }

  public getData(page?: number) {
    if (!page) { return; }

    this.isBusy = true;

    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<ProductListItemModel>>('/api/admin/catalog/product/list', {
      page: page,
      pageSize: 20,
      search: this.search
    }).subscribe({
      next: r => {
        this.items = r.items;

        this.page = page;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public addNew() {
    this.mRoute.navigate(['/products/edit/new']);
  }

  public deleteItem(id: string) {
    if (!confirm('Удалить этот продукт?')) {
      return;
    }

    this.isBusy = true;
    this.mApiService.delete(`/api/admin/catalog/product/${id}`).subscribe({
      next: () => {
        this.getData(this.page);
      },
      error: () => this.isBusy = false
    });
  }
}
